<template>
    <div>
        <div class="AffectedResourcesDetail-title">
            <Breadcrumb>
                <BreadcrumbItem to="/monitor/trustAdvisor">TrustAdvisor</BreadcrumbItem>
                <BreadcrumbItem>
                	<router-link :to='{ path: "/monitor/trustAdvisorDetail",query: {name:this.$route.query.name,accountId:this.$route.query.accountId,type:this.$route.query.type }}'>{{this.$route.query.name}}
                	</router-link>
                </BreadcrumbItem>
                <BreadcrumbItem>{{tableTitle}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
		<!-- 受影响资源-无关联的弹性 IP 地址 -->
        <Table :no-data-text="$t('common.noData')" :columns="unassociatedElasticIPAddressesColumns" :data="unassociatedElasticIPAddresses" style="width: 100.1%;" v-if="unassociatedElasticIPAddresses" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Amazon EBS 预配置 IOPS (SSD) 卷附加配置 -->
        <Table :no-data-text="$t('common.noData')" :columns="amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurationsColumns" :data="amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurations" style="width: 100.1%;" v-else-if="amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurations" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Amazon EBS 快照 -->
        <Table :no-data-text="$t('common.noData')" :columns="amazonEBSSnapshotsColumns" :data="amazonEBSSnapshots" style="width: 100.1%;" v-else-if="amazonEBSSnapshots" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Amazon RDS 备份 -->
        <Table :no-data-text="$t('common.noData')" :columns="amazonRDSBackupsColumns" :data="amazonRDSBackups" style="width: 100.1%;" v-else-if="amazonRDSBackups" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Amazon S3 存储桶记录 -->
        <Table :no-data-text="$t('common.noData')" :columns="amazonS3BucketLoggingColumns" :data="amazonS3BucketLogging" style="width: 100.1%;" v-else-if="amazonS3BucketLogging" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Amazon S3 存储桶权限 -->
        <Table :no-data-text="$t('common.noData')" :columns="amazonS3BucketPermissionsColumns" :data="amazonS3BucketPermissions" style="width: 100.1%;" v-else-if="amazonS3BucketPermissions" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Auto Scaling 组的运行状况检查 -->
        <Table :no-data-text="$t('common.noData')" :columns="autoScalingGroupHealthCheckColumns" :data="autoScalingGroupHealthCheck" style="width: 100.1%;" v-else-if="autoScalingGroupHealthCheck" :loading="affectedLoading"></Table>
        <!-- 受影响资源-Auto Scaling 组资源 -->
        <Table :no-data-text="$t('common.noData')" :columns="autoScalingGroupResourcesColumns" :data="autoScalingGroupResources" style="width: 100.1%;" v-else-if="autoScalingGroupResources" :loading="affectedLoading"></Table>
        <!-- 受影响资源-EC2 安全组中的大量规则 -->
        <Table :no-data-text="$t('common.noData')" :columns="largeNumberofRulesinanEC2SecurityGroupColumns" :data="largeNumberofRulesinanEC2SecurityGroup" style="width: 100.1%;" v-else-if="largeNumberofRulesinanEC2SecurityGroup" :loading="affectedLoading"></Table>
        <!-- 受影响资源-ELB Connection Draining -->
        <Table :no-data-text="$t('common.noData')" :columns="elbConnectionDrainingColumns" :data="elbConnectionDraining" style="width: 100.1%;" v-else-if="elbConnectionDraining" :loading="affectedLoading"></Table>
        <!-- 受影响资源-ELB 安全组 -->
        <Table :no-data-text="$t('common.noData')" :columns="elbSecurityGroupsColumns" :data="elbSecurityGroups" style="width: 100.1%;" v-else-if="elbSecurityGroups" :loading="affectedLoading"></Table>
        <!-- 受影响资源-ELB 侦听器安全性 -->
        <Table :no-data-text="$t('common.noData')" :columns="elbListenerSecurityColumns" :data="elbListenerSecurity" style="width: 100.1%;" v-else-if="elbListenerSecurity" :loading="affectedLoading"></Table>
        <!-- 受影响资源-IAM 密码策略 -->
        <Table :no-data-text="$t('common.noData')" :columns="iamPasswordPolicyColumns" :data="iamPasswordPolicy" style="width: 100.1%;" v-else-if="iamPasswordPolicy" :loading="affectedLoading"></Table>
        <!-- 受影响资源-安全组 – 不受限制的访问 -->
        <Table :no-data-text="$t('common.noData')" :columns="securityGroupsUnrestrictedAccessColumns" :data="securityGroupsUnrestrictedAccess" style="width: 100.1%;" v-else-if="securityGroupsUnrestrictedAccess" :loading="affectedLoading"></Table>
        <!-- 受影响资源-安全组 – 特定端口不受限制 -->
        <Table :no-data-text="$t('common.noData')" :columns="securityGroupsSpecificPortsUnrestrictedColumns" :data="securityGroupsSpecificPortsUnrestricted" style="width: 100.1%;" v-else-if="securityGroupsSpecificPortsUnrestricted" :loading="affectedLoading"></Table>
        <!-- 受影响资源-负载均衡器的优化 -->
        <Table :no-data-text="$t('common.noData')" :columns="loadBalancerOptimizationColumns" :data="loadBalancerOptimization" style="width: 100.1%;" v-else-if="loadBalancerOptimization" :loading="affectedLoading"></Table>
        <!-- 受影响资源-高使用率 Amazon EC2 实例 -->
        <Table :no-data-text="$t('common.noData')" :columns="highUtilizationAmazonEC2InstancesColumns" :data="highUtilizationAmazonEC2Instances" style="width: 100.1%;" v-else-if="highUtilizationAmazonEC2Instances" :loading="affectedLoading"></Table>
        <!-- 受影响资源-过度使用的 Amazon EBS 磁卷 -->
        <Table :no-data-text="$t('common.noData')" :columns="overutilizedAmazonEBSMagneticVolumesColumns" :data="overutilizedAmazonEBSMagneticVolumes" style="width: 100.1%;" v-else-if="overutilizedAmazonEBSMagneticVolumes" :loading="affectedLoading"></Table>
        <!-- 受影响资源-闲置的负载均衡器 -->
        <Table :no-data-text="$t('common.noData')" :columns="idleLoadBalancersColumns" :data="idleLoadBalancers" style="width: 100.1%;" v-else-if="idleLoadBalancers" :loading="affectedLoading"></Table>
        <!-- 受影响资源-应用于实例的大量 EC2 安全组规则 -->
        <Table :no-data-text="$t('common.noData')" :columns="largeNumberofEC2SecurityGroupRulesAppliedtoanInstanceColumns" :data="largeNumberofEC2SecurityGroupRulesAppliedtoanInstance" style="width: 100.1%;" v-else-if="largeNumberofEC2SecurityGroupRulesAppliedtoanInstance" :loading="affectedLoading"></Table>
    </div>
</template>

<script>
    export default {
        name: 'AffectedResourcesDetail',
        data(){
            return {
            	tableTitle:'',
            	affectedLoading:false,
            	unassociatedElasticIPAddressesColumns:[
            	{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.IPAddress'),
            		key:'ipAddress'
            	}],
				amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurationsColumns:[
				{
            		title:this.$t('ARD.regionAZ'),
            		key:'regionAZ'
            	},
            	{
            		title:this.$t('ARD.volumeID'),
            		key:'volumeID'
            	},
            	{
            		title:this.$t('ARD.volumeID'),
            		key:'volumeName'
            	},
            	{
            		title:this.$t('ARD.volumeAttachment'),
            		key:'volumeAttachment'
            	},
            	{
            		title:this.$t('ARD.instanceID'),
            		key:'instanceID'
            	},
            	{
            		title:this.$t('ARD.instanceType'),
            		key:'instanceType'
            	},
            	{
            		title:this.$t('ARD.ebsOptimize'),
            		key:'ebsOptimized'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	}],
				amazonEBSSnapshotsColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.volumeID'),
            		key:'volumeID'
            	},
            	{
            		title:this.$t('ARD.volumeName'),
            		key:'volumeName'
            	},
            	{
            		title:this.$t('ARD.snapshotID'),
            		key:'snapshotID'
            	},
            	{
            		title:this.$t('ARD.snapshotName'),
            		key:'snapshotName'
            	},
            	{
            		title:this.$t('ARD.snapshotAge'),
            		key:'snapshotAge'
            	},
            	{
            		title:this.$t('ARD.volumeAttachment'),
            		key:'volumeAttachment'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				amazonRDSBackupsColumns:[
				{
            		title:this.$t('ARD.regionAZ'),
            		key:'regionAZ'
            	},
            	{
            		title:this.$t('ARD.dbInstance'),
            		key:'dbInstance'
            	},
            	{
            		title:'VPC ID',
            		key:'vpcID'
            	},
            	{
            		title:this.$t('ARD.backupRetentionPeriod'),
            		key:'backupRetentionPeriod'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	}],
				amazonS3BucketLoggingColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.bucketName'),
            		key:'bucketName'
            	},
            	{
            		title:this.$t('ARD.tgtName'),
            		key:'targetName'
            	},
            	{
            		title:this.$t('ARD.tgtExist'),
            		key:'targetExists'
            	},
            	{
            		title:this.$t('ARD.sameOwner'),
            		key:'sameOwner'
            	},
            	{
            		title:this.$t('ARD.writeEnable'),
            		key:'writeEnabled'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				amazonS3BucketPermissionsColumns:[
				{
            		title:this.$t('ARD.regionName'),
            		key:'regionName'
            	},
            	{
            		title:this.$t('ARD.regionAPIParameter'),
            		key:'regionAPIParameter'
            	},
            	{
            		title:this.$t('ARD.bucketName'),
            		key:'bucketName'
            	},
            	{
            		title:this.$t('ARD.ACLAllowList'),
            		key:'aclAllowsList'
            	},
            	{
            		title:this.$t('ARD.ACLAllowUploadDelete'),
            		key:'aclAllowsUploadDelete'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'policyAllowsAccess'
            	},
            	{
            		title:this.$t('ARD.ignoredBucketName'),
            		key:'ignoredBucketName'
            	}],
				autoScalingGroupHealthCheckColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.ASGroupName'),
            		key:'autoScalingGroupName'
            	},
            	{
            		title:this.$t('ARD.loadBalancerAssociated'),
            		key:'loadBalancerAssociated'
            	},
            	{
            		title:this.$t('ARD.healthCheck'),
            		key:'healthCheck'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	}],
				autoScalingGroupResourcesColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.ASGroupName'),
            		key:'autoScalingGroupName'
            	},
            	{
            		title:this.$t('ARD.launchConfigName'),
            		key:'launchConfigurationName'
            	},
            	{
            		title:this.$t('ARD.launchType'),
            		key:'launchType'
            	},
            	{
            		title:this.$t('ARD.launchName'),
            		key:'launchName'
            	},
            	{
            		title:this.$t('ARD.resourceType'),
            		key:'resourceType'
            	},
            	{
            		title:this.$t('ARD.resourceName'),
            		key:'resourceName'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				largeNumberofRulesinanEC2SecurityGroupColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.securityGroupName'),
            		key:'securityGroupName'
            	},
            	{
            		title:this.$t('ARD.securityGroupID'),
            		key:'groupID'
            	},
            	{
            		title:this.$t('ARD.description'),
            		key:'description'
            	},
            	{
            		title:this.$t('ARD.instanceAmount'),
            		key:'instanceCount'
            	},
            	{
            		title:'VPC ID',
            		key:'vpcID'
            	},
            	{
            		title:this.$t('ARD.totalInboudRules'),
            		key:'totalInboundRules'
            	},
            	{
            		title:this.$t('ARD.totalOutboudRules'),
            		key:'totalOutboundRules'
            	}],
				elbConnectionDrainingColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.loadBalancerName'),
            		key:'loadBalancerName'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				elbSecurityGroupsColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.loadBalancerName'),
            		key:'loadBalancerName'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.securityGroupID'),
            		key:'securityGroupIDs'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				elbListenerSecurityColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.loadBalancerName'),
            		key:'loadBalancerName'
            	},
            	{
            		title:this.$t('ARD.loadBalancerPort'),
            		key:'loadBalancerPort'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				iamPasswordPolicyColumns:[
				{
            		title:this.$t('ARD.passwordPolicy'),
            		key:'passwordPolicy'
            	},
            	{
            		title:this.$t('ARD.upperCase'),
            		key:'uppercase'
            	},
            	{
            		title:this.$t('ARD.lowerCase'),
            		key:'lowercase'
            	},
            	{
            		title:this.$t('ARD.number'),
            		key:'number'
            	},
            	{
            		title:this.$t('ARD.nonAlphanumeric'),
            		key:'nonAlphanumeric'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				securityGroupsUnrestrictedAccessColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.securityGroupName'),
            		key:'securityGroupName'
            	},
            	{
            		title:this.$t('ARD.securityGroupID'),
            		key:'securityGroupID'
            	},
            	{
            		title:this.$t('ARD.protocol'),
            		key:'protocol'
            	},
            	{
            		title:this.$t('ARD.port'),
            		key:'port'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.ipRange'),
            		key:'ipRange'
            	}],
				securityGroupsSpecificPortsUnrestrictedColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.securityGroupName'),
            		key:'securityGroupName'
            	},
            	{
            		title:this.$t('ARD.securityGroupID'),
            		key:'securityGroupID'
            	},
            	{
            		title:this.$t('ARD.protocol'),
            		key:'protocol'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.port'),
            		key:'ports'
            	}],
				loadBalancerOptimizationColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.loadBalancerName'),
            		key:'loadBalancerName'
            	},
            	{
            		title:this.$t('ARD.zoneAmount'),
            		key:'ofZones'
            	},
            	{
            		title:this.$t('ARD.ZoneAInstance'),
            		key:'instancesinZonea'
            	},
            	{
            		title:this.$t('ARD.ZoneBInstance'),
            		key:'instancesinZoneb'
            	},
            	{
            		title:this.$t('ARD.ZoneCInstance'),
            		key:'instancesinZonec'
            	},
            	{
            		title:this.$t('ARD.ZoneDInstance'),
            		key:'instancesinZoned'
            	},
            	{
            		title:this.$t('ARD.ZoneEInstance'),
            		key:'instancesinZonee'
            	},
            	{
            		title:this.$t('ARD.ZoneFInstance'),
            		key:'instancesinZonef'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	}],
				highUtilizationAmazonEC2InstancesColumns:[
				{
            		title:this.$t('ARD.regionAZ'),
            		key:'regionAZ'
            	},
            	{
            		title:this.$t('ARD.instanceID'),
            		key:'instanceID'
            	},
            	{
            		title:this.$t('ARD.instanceName'),
            		key:'instanceName'
            	},
            	{
            		title:this.$t('ARD.instanceName'),
            		key:'instanceType'
            	},
            	{
            		title:this.$t('ARD.day1'),
            		key:'day1'
            	},
            	{
            		title:this.$t('ARD.day2'),
            		key:'day2'
            	},
            	{
            		title:this.$t('ARD.day3'),
            		key:'day3'
            	},
            	{
            		title:this.$t('ARD.day4'),
            		key:'day4'
            	},
            	{
            		title:this.$t('ARD.day5'),
            		key:'day5'
            	},
            	{
            		title:this.$t('ARD.day6'),
            		key:'day6'
            	},
            	{
            		title:this.$t('ARD.day7'),
            		key:'day7'
            	},
            	{
            		title:this.$t('ARD.day8'),
            		key:'day8'
            	},
            	{
            		title:this.$t('ARD.day9'),
            		key:'day9'
            	},
            	{
            		title:this.$t('ARD.day10'),
            		key:'day10'
            	},
            	{
            		title:this.$t('ARD.day11'),
            		key:'day11'
            	},
            	{
            		title:this.$t('ARD.day12'),
            		key:'day12'
            	},
            	{
            		title:this.$t('ARD.day13'),
            		key:'day13'
            	},
            	{
            		title:this.$t('ARD.day14'),
            		key:'day14'
            	},
            	{
            		title:this.$t('ARD.day14avgCPUUtlz'),
            		key:'day14AverageCPUUtilization'
            	},
            	{
            		title:this.$t('ARD.amtDaysCPUUtlzOver90'),
            		key:'numberofDaysover90%CPUUtilization'
            	}],
				overutilizedAmazonEBSMagneticVolumesColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.volumeID'),
            		key:'volumeID'
            	},
            	{
            		title:this.$t('ARD.volumeName'),
            		key:'volumeName'
            	},
            	{
            		title:this.$t('ARD.day1'),
            		key:'day1'
            	},
            	{
            		title:this.$t('ARD.day2'),
            		key:'day2'
            	},
            	{
            		title:this.$t('ARD.day3'),
            		key:'day3'
            	},
            	{
            		title:this.$t('ARD.day4'),
            		key:'day4'
            	},
            	{
            		title:this.$t('ARD.day5'),
            		key:'day5'
            	},
            	{
            		title:this.$t('ARD.day6'),
            		key:'day6'
            	},
            	{
            		title:this.$t('ARD.day7'),
            		key:'day7'
            	},
            	{
            		title:this.$t('ARD.day8'),
            		key:'day8'
            	},
            	{
            		title:this.$t('ARD.day9'),
            		key:'day9'
            	},
            	{
            		title:this.$t('ARD.day10'),
            		key:'day10'
            	},
            	{
            		title:this.$t('ARD.day11'),
            		key:'day11'
            	},
            	{
            		title:this.$t('ARD.day12'),
            		key:'day12'
            	},
            	{
            		title:this.$t('ARD.day13'),
            		key:'day13'
            	},
            	{
            		title:this.$t('ARD.day14'),
            		key:'day14'
            	},
            	{
            		title:this.$t('ARD.amountOfDaysOver'),
            		key:'numberofDaysOver'
            	},
            	{
            		title:this.$t('ARD.maxDailyMedian'),
            		key:'maxDailyMedian'
            	},
            	{
            		title:this.$t('ARD.status'),
            		key:'status'
            	}],
				idleLoadBalancersColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.loadBalancerName'),
            		key:'loadBalancerName'
            	},
            	{
            		title:this.$t('ARD.reason'),
            		key:'reason'
            	},
            	{
            		title:this.$t('ARD.estimateMonthlySaving'),
            		key:'estimatedMonthlySavings'
            	}],
				largeNumberofEC2SecurityGroupRulesAppliedtoanInstanceColumns:[
				{
            		title:this.$t('ARD.region'),
            		key:'region'
            	},
            	{
            		title:this.$t('ARD.instanceID'),
            		key:'instanceID'
            	},
            	{
            		title:this.$t('ARD.instanceName'),
            		key:'instanceName'
            	},
            	{
            		title:'VPC ID',
            		key:'vpcID'
            	},
            	{
            		title:this.$t('ARD.totalInboudRules'),
            		key:'totalInboundRules'
            	},
            	{
            		title:this.$t('ARD.totalOutboudRules'),
            		key:'totalOutboundRules'
            	}],
                unassociatedElasticIPAddresses:[],
				amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurations:[],
				amazonEBSSnapshots:[],
				amazonRDSBackups:[],
				amazonS3BucketLogging:[],
				amazonS3BucketPermissions:[],
				autoScalingGroupHealthCheck:[],
				autoScalingGroupResources:[],
				largeNumberofRulesinanEC2SecurityGroup:[],
				elbConnectionDraining:[],
				elbSecurityGroups:[],
				elbListenerSecurity:[],
				iamPasswordPolicy:[],
				securityGroupsUnrestrictedAccess:[],
				securityGroupsSpecificPortsUnrestricted:[],
				loadBalancerOptimization:[],
				highUtilizationAmazonEC2Instances:[],
				overutilizedAmazonEBSMagneticVolumes:[],
				idleLoadBalancers:[],
				largeNumberofEC2SecurityGroupRulesAppliedtoanInstance:[]
            }
        },
        mounted () {
            this.checkAWSTrustedAdvisorAffectedResources();
        },
        methods: {
            // 受影响资源表格
            checkAWSTrustedAdvisorAffectedResources:function(){
            	this.affectedLoading=true;
            	this.$api.trustedAdvisor.checkAWSTrustedAdvisorAffectedResources({
                    "accountId":this.$route.query.accountId,
                    "type":this.$route.query.type,
                    "id":this.$route.query.id
                })
                .then(res => {
                	this.affectedLoading=false;
                	this.tableTitle=res.data.name;
                    this.unassociatedElasticIPAddresses=res.data.unassociatedElasticIPAddresses;
					this.amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurations=res.data.amazonEBSProvisionedIOPSSSDVolumeAttachmentConfigurations;
					this.amazonEBSSnapshots=res.data.amazonEBSSnapshots;
					this.amazonRDSBackups=res.data.amazonRDSBackups;
					this.amazonS3BucketLogging=res.data.amazonS3BucketLoggings;
					this.amazonS3BucketPermissions=res.data.amazonS3BucketPermissions;
					this.autoScalingGroupHealthCheck=res.data.autoScalingGroupHealthChecks;
					this.autoScalingGroupResources=res.data.autoScalingGroupResources;
					this.largeNumberofRulesinanEC2SecurityGroup=res.data.largeNumberofRulesinanEC2SecurityGroups;
					this.elbConnectionDraining=res.data.elbConnectionDrainings;
					this.elbSecurityGroups=res.data.elbSecurityGroups;
					this.elbListenerSecurity=res.data.elbListenerSecurities;
					this.iamPasswordPolicy=res.data.iamPasswordPolicies;
					this.securityGroupsUnrestrictedAccess=res.data.securityGroupsUnrestrictedAccesses;
					this.securityGroupsSpecificPortsUnrestricted=res.data.securityGroupsSpecificPortsUnrestricteds;
					this.loadBalancerOptimization=res.data.loadBalancerOptimizations;
					this.highUtilizationAmazonEC2Instances=res.data.highUtilizationAmazonEC2Instances;
					this.overutilizedAmazonEBSMagneticVolumes=res.data.overutilizedAmazonEBSMagneticVolumes;
					this.idleLoadBalancers=res.data.idleLoadBalancers;
					this.largeNumberofEC2SecurityGroupRulesAppliedtoanInstance=res.data.largeNumberofEC2SecurityGroupRulesAppliedtoanInstances;
                })
            }
        }
    }
</script>

<style scoped>
    .AffectedResourcesDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/trustAdvisor/trustAdvisor_list/AffectedResourcesDetail.vue